import { Actor, Hands, WieldMode } from "./Actor";

export const getActiveAttack = (actor: Actor) => {
  if (actor.wielding.mode === WieldMode.twoHanded) {
    return (
      actor.wielding.left?.breed.attacks?.twohanded ||
      actor.wielding.right?.breed.attacks?.twohanded ||
      actor.breed.baseAttack
    );
  } else if (actor.wielding.activeHand === Hands.LEFT) {
    const left = actor.wielding.left;
    return left?.breed.attacks?.onehanded || actor.breed.baseAttack;
  } else {
    const right = actor.wielding.right;
    return right?.breed.attacks?.onehanded || actor.breed.baseAttack;
  }
};
